
import {UserSession} from "../contract-features-3/domain";
import {ContractType} from "../../../integration/representation/contract";

export default class ContractlistState {
    constructor(
        readonly contracts: ListContract[] = [],
        readonly page: number = 1,
        readonly searchString: string = "",
        readonly typeFilter: ContractType | "all" = "all",
        readonly showOtherPeoplesContracts: boolean = false,
        readonly sortByField: string = "lastModified",
        readonly isAscending: boolean = false,
        readonly currentUser: UserSession = null,
        readonly fetchingContracts: boolean = true,
        readonly showArchivedContracts: boolean = false,
        readonly contractsWithChangeIndicator: { [key: string]: boolean } = {},
        readonly totalNumberOfContractsWithCurrentFilter: number = 0,
    ) { }

    private create(overrides: Partial<ContractlistState>) {
        const params = {...this, ...overrides};
        const state = new ContractlistState(
            params.contracts,
            params.page,
            params.searchString,
            params.typeFilter,
            params.showOtherPeoplesContracts,
            params.sortByField,
            params.isAscending,
            params.currentUser,
            params.fetchingContracts,
            params.showArchivedContracts,
            params.contractsWithChangeIndicator,
            params.totalNumberOfContractsWithCurrentFilter,
        );
        console.dir(state);
        return state;
    }

    public withContracts(contracts: ListContract[]) {
        return this.create({contracts});
    }

    public withPage(page: number){
        return this.create({page});
    }

    public withSortField(sortByField: string){
        return this.create({sortByField});
    }

    public withSortAscending(isAscending: boolean){
        return this.create({isAscending});
    }

    public withSearchString(searchString: string){
        return this.create({searchString});
    }

    public withTypeFilter(typeFilter: ContractType | "all"){
        return this.create({typeFilter: typeFilter});
    }

    public withShowOtherPeoplesContracts(showOtherPeoplesContracts: boolean){
        return this.create({showOtherPeoplesContracts: showOtherPeoplesContracts});
    }

    public withCurrentUser(currentUser: UserSession){
        return this.create({currentUser})
    }


    public withFetchingContracts(fetchingContracts: boolean){
        return this.create({fetchingContracts});
    }

    public withArchivedFilter(showArchivedContracts: boolean){
        return this.create({showArchivedContracts})
    }

    public withChangeIndicators(contractsWithChangeIndicator: { [key: string]: boolean }){
        return this.create({contractsWithChangeIndicator})
    }

    public withTotalNumberOfContractsWithCurrentFilter(totalNumberOfContractsWithCurrentFilter: number){
        return this.create({totalNumberOfContractsWithCurrentFilter});
    }
}

export type ListContract = {
    archivedState: ArchivedState,
    assignee: string,
    assigneeDisplayName: string,
    comments: Object[],
    constructionManager?: string,
    contractor?: string,
    contributors: contractUser[],
    county?: string,
    municipality?: string,
    fkbObjectList: Object[],
    id: string,
    lastModified: string,
    mapComments: Object[],
    milestones: Milestone[],
    name: string,
    referenceId?: string,
    road?: string,
    status: Status,
    contractType?: string,
    completionDate?: string,
    searchIndex: string,
    canDelete: boolean,
    canArchive: boolean,
    hasChanges: boolean,
    contractGroup?: string
}

export type ArchivedState = "OPEN" | "ARCHIVED";

export type Status = 'PLANLAGT' | 'UTLYST' | 'IGANGSATT' | 'FERDIG';

export type Milestone = {
    approved: boolean,
    deadline: string,
    description: string,
    id: string,
    name: string,
}

export type contractUser = {
    username: string,
}



